import { isBrowser } from '../helpers';

export default async function moduleJquery() {
  if (isBrowser() && !window.$) {
    return await import(/* webpackChunkName: "jQuery" */ 'jquery').then(
      (jQuery) => {
        window.$ = jQuery.default;
      },
    );
  }
}
